import moment from 'moment';
import { Box, Grid, Typography } from '@mui/material';
import { cloneDeep } from 'lodash';
import VerificationStatusIcon from '@features/workspace/components/verification-status-icon';
import { DocumentTypeLabelEnum, UNKNOWN } from '@utils/constants';
import config from '@/app/configs/config';

type Props = {
  items: Array<any>;
  showVerifiedLabel: boolean;
  showModifiedDate: boolean;
};

// Items format as per convertDocument in model helper
export function Documents({
  items,
  showVerifiedLabel,
  showModifiedDate,
}: Props) {
  if (!items || items?.length === 0) {
    return (
      <>
        <Typography className="labelHeader" variant="subtitle2">
          <i>No documents, yet.</i>
        </Typography>
      </>
    );
  }

  // Sort documents
  const documents = cloneDeep(items).sort((a: any, b: any) =>
    a.date < b.date ? 1 : -1
  );

  return (
    <Box display="flex" flexDirection="column" width="100%">
      {documents.map((doc) => (
        <Grid key={`document-${doc.id}`} container alignItems="center">
          {/* Left side */}
          <Grid item sm={6} xs={9}>
            {showVerifiedLabel && (
              <Box display="flex">
                <Typography className="labelHeader" variant="subtitle2">
                  {doc?.isVerified === true ? 'Verified' : ''}
                </Typography>
              </Box>
            )}
            <Box alignItems="center" display="flex">
              <Box alignItems="center" display="flex">
                <VerificationStatusIcon isVerified={!!doc?.isVerified} />
              </Box>

              <Box display="flex">
                <Typography
                  sx={{ color: '#4B4B4B !important' }}
                  variant="subtitle2"
                >
                  {DocumentTypeLabelEnum[doc?.documentType] || UNKNOWN}
                </Typography>
              </Box>
            </Box>
          </Grid>
          {/* Right side */}
          <Grid item sm={6} xs={3}>
            {showModifiedDate && (
              <Box display="flex">
                <Typography className="labelHeader" variant="subtitle2">
                  {moment(doc?.date).format(config.dateFormat)}
                </Typography>
              </Box>
            )}
          </Grid>
        </Grid>
      ))}
    </Box>
  );
}
